<template>
  <div
    class="heim-toast"
    :class="[toastOpened?'opened':'', toastMode]"
  >
    <div class="message">{{ $t(toastMessage) }}</div>
    <slot />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "heim-toast",
  props: {
    message: String,
    duration: {
      type: String,
      default: "3000"
    }
  },
  computed: {
    ...mapState(["toastOpened", "toastMessage", "toastMode"])
  },
  methods: {
    closeToast() {
      this.$store.dispatch("setOpenToast", { opened: false });
      this.$store.dispatch("clearToastTimout");
    }
  },
  watch: {
    toastOpened(value) {
      if (!value) return;
      const timeout = setTimeout(this.closeToast, Number(this.duration));
      this.$store.dispatch("setToastTimout", { timeout });
    }
  }
};
</script>

<style scoped>
.heim-toast {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 1em;
  right: 1em;
  left: 1em;
  background-color: var(--heim-secondary-color);
  -webkit-box-shadow: var(--app-shadow);
  box-shadow: var(--app-shadow);
  border-radius: 3px;
  box-shadow: var(--heim-shadow-hight);
  z-index: 30;
  padding: 16px 24px;
  transform: translateY(100px);
  transition: transform 0.3s var(--heim-transition);
  box-sizing: border-box;
  cursor: default;
}

.message {
  display: inline-block;
  color: var(--heim-white-color);
}

.heim-toast .paper-button:hover {
  color: #ffff00;
  box-shadow: none;
}
.opened {
  transform: translateY(0);
}

.heim-toast.notice {
  background-color: var(--heim-secondary-color);
}
.heim-toast.notice .paper-button {
  color: #ffffff;
  background-color: transparent;
}
.heim-toast.notice .paper-button:hover {
  color: #ffff00;
}
.heim-toast.error {
  background-color: #f84242;
}
.heim-toast.error .paper-button {
  color: #912f2f;
  background-color: transparent;
}
.heim-toast.error .paper-button:hover {
  color: #ffff00;
}
/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .heim-toast {
    min-width: 20rem;
    left: auto;
  }
}
</style>
